import LanguageSwitch from "app/components/LanguageSwitch"
import { useTranslate } from "hooks/translate"
import { forwardRef } from "react"
import { useAppflow } from "app/hooks/useAppFlow"
import { StyledCurrentStep, StyledHeader } from "./style"

interface HeaderProps {
  numberOfSteps?: number;
}

const Header = forwardRef<HTMLDivElement, HeaderProps>(({ numberOfSteps = 0 }, ref) => {
  const { step } = useAppflow()
  const { t } = useTranslate()

  return (
    <StyledHeader ref={ref}>
      <span>
        {t("form.step_indicator", {
          step: <StyledCurrentStep>{step}</StyledCurrentStep>,
          maxStep: numberOfSteps
        })}
      </span>
      <LanguageSwitch />
    </StyledHeader>
  )
})

export default Header
